<div class="container-fluid py-4">

  <!-- ======================================================
       HEADER
  ======================================================= -->

  <div class="d-flex flex-wrap justify-content-between
              align-items-center gap-3 mb-4">

    <div>

      <h4 class="fw-bold mb-1">

        <i class="bi bi-list-nested me-2"></i>

        Menu Items Settings

      </h4>

      <p class="text-muted mb-0">

        Create and manage dynamic ERP navigation menu items.

      </p>

    </div>


    <div class="d-flex gap-2">

      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="openJsonModal()">

        <i class="bi bi-code-slash me-2"></i>

        JSON

      </button>


      <button
        type="button"
        class="btn btn-primary"
        (click)="openAddModal()">

        <i class="bi bi-plus-lg me-2"></i>

        Add Menu Item

      </button>

    </div>

  </div>


  <!-- ======================================================
       SUMMARY
  ======================================================= -->

  <div class="row g-3 mb-4">

    <div class="col-12 col-sm-6 col-xl-3">

      <div class="summary-card">

        <div class="summary-icon bg-primary-subtle text-primary">

          <i class="bi bi-list"></i>

        </div>

        <div>

          <small class="text-muted">
            Total Items
          </small>

          <h4 class="fw-bold mb-0">
            {{ menuItems.length }}
          </h4>

        </div>

      </div>

    </div>


    <div class="col-12 col-sm-6 col-xl-3">

      <div class="summary-card">

        <div class="summary-icon bg-success-subtle text-success">

          <i class="bi bi-menu-button-wide"></i>

        </div>

        <div>

          <small class="text-muted">
            Main Menus
          </small>

          <h4 class="fw-bold mb-0">
            {{ rootMenus.length }}
          </h4>

        </div>

      </div>

    </div>


    <div class="col-12 col-sm-6 col-xl-3">

      <div class="summary-card">

        <div class="summary-icon bg-info-subtle text-info">

          <i class="bi bi-diagram-3"></i>

        </div>

        <div>

          <small class="text-muted">
            Child Menus
          </small>

          <h4 class="fw-bold mb-0">
            {{ menuItems.length - rootMenus.length }}
          </h4>

        </div>

      </div>

    </div>


    <div class="col-12 col-sm-6 col-xl-3">

      <div class="summary-card">

        <div class="summary-icon bg-warning-subtle text-warning">

          <i class="bi bi-eye"></i>

        </div>

        <div>

          <small class="text-muted">
            Active / Visible
          </small>

          <h4 class="fw-bold mb-0">

            {{
              menuItems.filter(
                item => item.is_active && !item.hidden
              ).length
            }}

          </h4>

        </div>

      </div>

    </div>

  </div>


  <!-- ======================================================
       SEARCH / FILTER
  ======================================================= -->

  <div class="card border-0 shadow-sm mb-4">

    <div class="card-body">

      <div class="row g-3 align-items-end">

        <div class="col-12 col-lg-6">

          <label class="form-label fw-semibold">
            Search Menu
          </label>

          <div class="input-group">

            <span class="input-group-text bg-white">

              <i class="bi bi-search"></i>

            </span>

            <input
              type="text"
              class="form-control"
              name="searchText"
              [(ngModel)]="searchText"
              placeholder="Search menu title, route, component..."
            >

          </div>

        </div>


        <div class="col-12 col-sm-6 col-lg-2">

          <label class="form-label fw-semibold">
            Menu Type
          </label>

          <select
            class="form-select"
            name="filterType"
            [(ngModel)]="filterType">

            <option value="all">
              All
            </option>

            <option value="parent">
              Main Menu
            </option>

            <option value="child">
              Child Menu
            </option>

          </select>

        </div>


        <div class="col-12 col-sm-6 col-lg-2">

          <label class="form-label fw-semibold">
            Status
          </label>

          <select
            class="form-select"
            name="filterStatus"
            [(ngModel)]="filterStatus">

            <option value="all">
              All
            </option>

            <option value="active">
              Active
            </option>

            <option value="inactive">
              Inactive
            </option>

            <option value="hidden">
              Hidden
            </option>

          </select>

        </div>


        <div class="col-12 col-lg-2">

          <button
            type="button"
            class="btn btn-light border w-100"
            (click)="resetFilters()">

            <i class="bi bi-arrow-counterclockwise me-2"></i>

            Reset

          </button>

        </div>

      </div>

    </div>

  </div>


  <!-- ======================================================
       MENU TABLE
  ======================================================= -->

  <div class="card border-0 shadow-sm">

    <div class="card-body p-0">

      <div class="table-responsive">

        <table class="table table-hover align-middle mb-0">

          <thead class="table-light">

            <tr>

              <th class="ps-4">
                #
              </th>

              <th>
                Menu Item
              </th>

              <th>
                Parent
              </th>

              <th>
                Route / Action
              </th>

              <th>
                Order
              </th>

              <th>
                Access
              </th>

              <th>
                Status
              </th>

              <th class="text-end pe-4">
                Actions
              </th>

            </tr>

          </thead>


          <tbody>

            @for (
              item of paginatedMenus;
              track item.id;
              let i = $index
            ) {

              <tr
                draggable="true"
                (dragstart)="onDragStart(item)"
                (dragover)="onDragOver($event)"
                (drop)="onDrop(item)"
                class="menu-row">


                <!-- NUMBER -->

                <td class="ps-4">

                  <div class="drag-number">

                    <i class="bi bi-grip-vertical"></i>

                    {{
                      (currentPage - 1) * pageSize + i + 1
                    }}

                  </div>

                </td>


                <!-- MENU -->

                <td>

                  <div class="d-flex align-items-center gap-3">

                    <div
                      class="menu-icon"
                      [style.background-color]="item.clrCode">

                      <i
                        class="bi"
                        [ngClass]="item.icon">
                      </i>

                    </div>


                    <div>

                      <div class="fw-semibold">

                        @if (item.parentId) {

                          <i class="bi bi-arrow-return-right
                                    text-muted me-1">
                          </i>

                        }

                        {{ item.title }}

                      </div>

                      <small class="text-muted">

                        {{ item.desc }}

                      </small>

                    </div>

                  </div>

                </td>


                <!-- PARENT -->

                <td>

                  @if (item.parentId) {

                    <span class="parent-badge">

                      <i class="bi bi-folder2 me-1"></i>

                      {{ getParentName(item.parentId) }}

                    </span>

                  } @else {

                    <span class="text-muted">

                      <i class="bi bi-house me-1"></i>

                      Main Menu

                    </span>

                  }

                </td>


                <!-- ROUTE -->

                <td>

                  <div class="route-info">

                    <code>
                      {{ item.route || item.optClick }}
                    </code>

                    @if (item.component) {

                      <small class="d-block text-muted mt-1">

                        {{ item.component }}

                      </small>

                    }

                  </div>

                </td>


                <!-- SORT -->

                <td>

                  <span class="order-badge">

                    {{ item.sort_ord }}

                  </span>

                </td>


                <!-- ACCESS -->

                <td>

                  <div class="d-flex flex-wrap gap-1">

                    @if (item.sa_only) {

                      <span
                        class="badge bg-warning-subtle text-warning-emphasis">

                        <i class="bi bi-shield-lock me-1"></i>

                        SA

                      </span>

                    }


                    @if (item.locked) {

                      <span
                        class="badge bg-danger-subtle text-danger">

                        <i class="bi bi-lock me-1"></i>

                        Locked

                      </span>

                    }


                    @if (item.passcode) {

                      <span
                        class="badge bg-primary-subtle text-primary">

                        <i class="bi bi-key me-1"></i>

                        PIN

                      </span>

                    }

                  </div>

                </td>


                <!-- STATUS -->

                <td>

                  @if (!item.is_active) {

                    <span class="badge bg-secondary">
                      Inactive
                    </span>

                  } @else if (item.hidden) {

                    <span class="badge bg-secondary-subtle text-secondary">
                      <i class="bi bi-eye-slash me-1"></i>
                      Hidden
                    </span>

                  } @else {

                    <span class="badge bg-success-subtle text-success">

                      <i class="bi bi-check-circle me-1"></i>

                      Active

                    </span>

                  }

                </td>


                <!-- ACTIONS -->

                <td class="text-end pe-4">

                  <div class="btn-group">

                    <button
                      type="button"
                      class="btn btn-sm btn-light border"
                      title="Add Child Menu"
                      (click)="openAddModal(item.id)">

                      <i class="bi bi-node-plus"></i>

                    </button>


                    <button
                      type="button"
                      class="btn btn-sm btn-light border"
                      title="View"
                      (click)="openViewModal(item)">

                      <i class="bi bi-eye"></i>

                    </button>


                    <button
                      type="button"
                      class="btn btn-sm btn-light border"
                      title="Edit"
                      (click)="openEditModal(item)">

                      <i class="bi bi-pencil"></i>

                    </button>


                    <button
                      type="button"
                      class="btn btn-sm btn-light border"
                      title="Delete"
                      (click)="openDeleteModal(item)">

                      <i class="bi bi-trash text-danger"></i>

                    </button>

                  </div>

                </td>

              </tr>

            }


            @if (!paginatedMenus.length) {

              <tr>

                <td
                  colspan="8"
                  class="text-center py-5">

                  <i class="bi bi-menu-button-wide
                            fs-1 text-muted">
                  </i>

                  <h6 class="mt-3">
                    No menu items found
                  </h6>

                  <p class="text-muted mb-0">
                    Create a menu item or change the filters.
                  </p>

                </td>

              </tr>

            }

          </tbody>

        </table>

      </div>

    </div>


    <!-- ====================================================
         PAGINATION
    ===================================================== -->

    @if (filteredMenus.length) {

      <div
        class="card-footer bg-white border-0
               d-flex flex-wrap justify-content-between
               align-items-center gap-3">

        <div class="small text-muted">

          Showing

          <strong>
            {{ startRecord }}
          </strong>

          -

          <strong>
            {{ endRecord }}
          </strong>

          of

          <strong>
            {{ filteredMenus.length }}
          </strong>

        </div>


        <div class="d-flex gap-2 align-items-center">

          <select
            class="form-select form-select-sm"
            style="width:80px"
            name="pageSize"
            [(ngModel)]="pageSize"
            (ngModelChange)="onPageSizeChange()">

            <option [ngValue]="5">
              5
            </option>

            <option [ngValue]="10">
              10
            </option>

            <option [ngValue]="25">
              25
            </option>

            <option [ngValue]="50">
              50
            </option>

          </select>


          <ul class="pagination pagination-sm mb-0">

            <li
              class="page-item"
              [class.disabled]="currentPage === 1">

              <button
                class="page-link"
                type="button"
                (click)="previousPage()">

                <i class="bi bi-chevron-left"></i>

              </button>

            </li>


            @for (
              page of pages;
              track page
            ) {

              <li
                class="page-item"
                [class.active]="currentPage === page">

                <button
                  class="page-link"
                  type="button"
                  (click)="goToPage(page)">

                  {{ page }}

                </button>

              </li>

            }


            <li
              class="page-item"
              [class.disabled]="currentPage === totalPages">

              <button
                class="page-link"
                type="button"
                (click)="nextPage()">

                <i class="bi bi-chevron-right"></i>

              </button>

            </li>

          </ul>

        </div>

      </div>

    }

  </div>


  <!-- ======================================================
       LIVE MENU PREVIEW
  ======================================================= -->

  <div class="card border-0 shadow-sm mt-4">

    <div class="card-header bg-white border-0 pt-4">

      <h5 class="fw-bold mb-1">

        <i class="bi bi-layout-sidebar-inset me-2"></i>

        Menu Preview

      </h5>

      <small class="text-muted">

        Preview of how the dynamic menu hierarchy will appear.

      </small>

    </div>


    <div class="card-body">

      <div class="menu-preview">

        @for (
          parent of rootMenus;
          track parent.id
        ) {

          @if (
            parent.is_active &&
            !parent.hidden
          ) {

            <div class="preview-parent">

              <div class="preview-menu-item">

                <div
                  class="preview-icon"
                  [style.background-color]="parent.clrCode">

                  <i
                    class="bi"
                    [ngClass]="parent.icon">
                  </i>

                </div>

                <span>
                  {{ parent.title }}
                </span>

                @if (getChildren(parent.id).length) {

                  <i class="bi bi-chevron-down ms-auto"></i>

                }

              </div>


              @if (getChildren(parent.id).length) {

                <div class="preview-children">

                  @for (
                    child of getChildren(parent.id);
                    track child.id
                  ) {

                    @if (
                      child.is_active &&
                      !child.hidden
                    ) {

                      <div class="preview-child">

                        <i
                          class="bi"
                          [ngClass]="child.icon">
                        </i>

                        {{ child.title }}

                      </div>

                    }

                  }

                </div>

              }

            </div>

          }

        }

      </div>

    </div>

  </div>

</div>


<!-- ==========================================================
     ADD / EDIT MODAL
=========================================================== -->

@if (showFormModal) {

  <div class="modal-backdrop-custom">

    <div class="modal modal-dialog modal-lg modal-dialog-centered">

      <div class="modal-content border-0 shadow-lg">

        <div class="modal-header">

          <h5 class="modal-title fw-bold">

            <i
              class="bi me-2"
              [ngClass]="
                isEditMode
                  ? 'bi-pencil-square'
                  : 'bi-plus-circle'
              ">
            </i>

            {{ isEditMode ? 'Edit Menu Item' : 'Add Menu Item' }}

          </h5>


          <button
            type="button"
            class="btn-close"
            (click)="closeFormModal()">
          </button>

        </div>


        <div class="modal-body">

          <div class="row g-4">


            <!-- =================================================
                 BASIC DETAILS
            ================================================== -->

            <div class="col-12">

              <div class="section-title">

                <i class="bi bi-info-circle"></i>

                Basic Menu Information

              </div>

            </div>


            <div class="col-md-8">

              <label class="form-label fw-semibold">

                Menu Title

                <span class="text-danger">*</span>

              </label>

              <input
                type="text"
                class="form-control"
                name="title"
                [(ngModel)]="formData.title"
                placeholder="Organizations">

            </div>


            <div class="col-md-4">

              <label class="form-label fw-semibold">
                Bootstrap Icon
              </label>

              <div class="input-group">

                <span class="input-group-text">

                  <i
                    class="bi"
                    [ngClass]="formData.icon">
                  </i>

                </span>

                <input
                  type="text"
                  class="form-control"
                  name="icon"
                  [(ngModel)]="formData.icon"
                  placeholder="bi-buildings">

              </div>

            </div>


            <div class="col-12">

              <label class="form-label fw-semibold">
                Description
              </label>

              <textarea
                class="form-control"
                name="desc"
                rows="2"
                [(ngModel)]="formData.desc"
                placeholder="Add new organization details">
              </textarea>

            </div>


            <!-- =================================================
                 HIERARCHY
            ================================================== -->

            <div class="col-12">

              <div class="section-title">

                <i class="bi bi-diagram-3"></i>

                Menu Hierarchy

              </div>

            </div>


            <div class="col-md-6">

              <label class="form-label fw-semibold">
                Parent Menu
              </label>

              <select
                class="form-select"
                name="parentId"
                [(ngModel)]="formData.parentId">

                <option [ngValue]="null">
                  — Main Menu —
                </option>

                @for (
                  item of rootMenus;
                  track item.id
                ) {

                  @if (
                    !isEditMode ||
                    item.id !== formData.id
                  ) {

                    <option [ngValue]="item.id">

                      {{ item.title }}

                    </option>

                  }

                }

              </select>

              <small class="text-muted">
                Select a parent to create a submenu.
              </small>

            </div>


            <div class="col-md-3">

              <label class="form-label fw-semibold">
                Sort Order
              </label>

              <input
                type="number"
                min="1"
                class="form-control"
                name="sort_ord"
                [(ngModel)]="formData.sort_ord">

            </div>


            <div class="col-md-3">

              <label class="form-label fw-semibold">
                Menu Color
              </label>

              <div class="input-group">

                <input
                  type="color"
                  class="form-control form-control-color"
                  name="clrCode"
                  [(ngModel)]="formData.clrCode">

                <input
                  type="text"
                  class="form-control"
                  name="clrCodeText"
                  [(ngModel)]="formData.clrCode">

              </div>

            </div>


            <!-- =================================================
                 NAVIGATION
            ================================================== -->

            <div class="col-12">

              <div class="section-title">

                <i class="bi bi-signpost-2"></i>

                Navigation Configuration

              </div>

            </div>


            <div class="col-md-4">

              <label class="form-label fw-semibold">
                Option Key
              </label>

              <input
                type="text"
                class="form-control"
                name="optClick"
                [(ngModel)]="formData.optClick"
                placeholder="org">

            </div>


            <div class="col-md-4">

              <label class="form-label fw-semibold">
                Route
              </label>

              <input
                type="text"
                class="form-control"
                name="route"
                [(ngModel)]="formData.route"
                placeholder="/organizations">

            </div>


            <div class="col-md-4">

              <label class="form-label fw-semibold">
                Angular Component
              </label>

              <input
                type="text"
                class="form-control"
                name="component"
                [(ngModel)]="formData.component"
                placeholder="OrgListComponent">

            </div>


            <!-- =================================================
                 ACCESS / VISIBILITY
            ================================================== -->

            <div class="col-12">

              <div class="section-title">

                <i class="bi bi-shield-check"></i>

                Access & Visibility

              </div>

            </div>


            <div class="col-12">

              <div class="row g-2">


                <div class="col-12 col-sm-6 col-lg-3">

                  <label class="setting-card">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="is_active"
                      [(ngModel)]="formData.is_active">

                    <span>

                      <strong>
                        Active
                      </strong>

                      <small>
                        Show menu when enabled
                      </small>

                    </span>

                  </label>

                </div>


                <div class="col-12 col-sm-6 col-lg-3">

                  <label class="setting-card">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="hidden"
                      [(ngModel)]="formData.hidden">

                    <span>

                      <strong>
                        Hidden
                      </strong>

                      <small>
                        Hide from navigation
                      </small>

                    </span>

                  </label>

                </div>


                <div class="col-12 col-sm-6 col-lg-3">

                  <label class="setting-card">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="locked"
                      [(ngModel)]="formData.locked">

                    <span>

                      <strong>
                        Locked
                      </strong>

                      <small>
                        Restrict access
                      </small>

                    </span>

                  </label>

                </div>


                <div class="col-12 col-sm-6 col-lg-3">

                  <label class="setting-card">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="passcode"
                      [(ngModel)]="formData.passcode">

                    <span>

                      <strong>
                        Passcode
                      </strong>

                      <small>
                        Require passcode
                      </small>

                    </span>

                  </label>

                </div>


                <div class="col-12 col-sm-6 col-lg-3">

                  <label class="setting-card">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="sa_only"
                      [(ngModel)]="formData.sa_only">

                    <span>

                      <strong>
                        Super Admin Only
                      </strong>

                      <small>
                        Only SA can see menu
                      </small>

                    </span>

                  </label>

                </div>


                <div class="col-12 col-sm-6 col-lg-3">

                  <label class="setting-card">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="for_module"
                      [(ngModel)]="formData.for_module">

                    <span>

                      <strong>
                        For Module
                      </strong>

                      <small>
                        Module-specific menu
                      </small>

                    </span>

                  </label>

                </div>

              </div>

            </div>


          </div>

        </div>


        <div class="modal-footer">

          <button
            type="button"
            class="btn btn-light border"
            (click)="closeFormModal()">

            Cancel

          </button>


          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!formData.title.trim()"
            (click)="saveMenu()">

            <i
              class="bi me-2"
              [ngClass]="
                isEditMode
                  ? 'bi-check-lg'
                  : 'bi-plus-lg'
              ">
            </i>

            {{ isEditMode ? 'Update Menu' : 'Save Menu' }}

          </button>

        </div>

      </div>

    </div>

  </div>

}


<!-- ==========================================================
     VIEW MODAL
=========================================================== -->

@if (showViewModal && selectedMenu) {

  <div class="modal-backdrop-custom">

    <div class="modal modal-dialog modal-lg modal-dialog-centered">

      <div class="modal-content border-0 shadow-lg">

        <div class="modal-header">

          <h5 class="modal-title fw-bold">

            <i class="bi bi-eye me-2"></i>

            Menu Item Details

          </h5>

          <button
            type="button"
            class="btn-close"
            (click)="closeViewModal()">
          </button>

        </div>


        <div class="modal-body">

          <div class="text-center mb-4">

            <div
              class="menu-icon menu-icon-large mx-auto"
              [style.background-color]="selectedMenu.clrCode">

              <i
                class="bi"
                [ngClass]="selectedMenu.icon">
              </i>

            </div>

            <h4 class="fw-bold mt-3 mb-1">
              {{ selectedMenu.title }}
            </h4>

            <p class="text-muted mb-0">
              {{ selectedMenu.desc }}
            </p>

          </div>


          <div class="row g-3">

            <div class="col-md-6">

              <div class="detail-box">

                <small>
                  Parent Menu
                </small>

                <strong>
                  {{ getParentName(selectedMenu.parentId) }}
                </strong>

              </div>

            </div>


            <div class="col-md-6">

              <div class="detail-box">

                <small>
                  Sort Order
                </small>

                <strong>
                  {{ selectedMenu.sort_ord }}
                </strong>

              </div>

            </div>


            <div class="col-md-6">

              <div class="detail-box">

                <small>
                  Route
                </small>

                <strong>
                  {{ selectedMenu.route }}
                </strong>

              </div>

            </div>


            <div class="col-md-6">

              <div class="detail-box">

                <small>
                  Option Key
                </small>

                <strong>
                  {{ selectedMenu.optClick }}
                </strong>

              </div>

            </div>


            <div class="col-md-6">

              <div class="detail-box">

                <small>
                  Component
                </small>

                <strong>
                  {{ selectedMenu.component }}
                </strong>

              </div>

            </div>


            <div class="col-md-6">

              <div class="detail-box">

                <small>
                  Color
                </small>

                <strong>
                  {{ selectedMenu.clrCode }}
                </strong>

              </div>

            </div>


            <div class="col-12">

              <div class="detail-box">

                <small>
                  Settings
                </small>

                <div class="d-flex flex-wrap gap-2 mt-2">

                  @if (selectedMenu.is_active) {

                    <span class="badge bg-success">
                      Active
                    </span>

                  } @else {

                    <span class="badge bg-secondary">
                      Inactive
                    </span>

                  }


                  @if (selectedMenu.hidden) {

                    <span class="badge bg-secondary">
                      Hidden
                    </span>

                  }


                  @if (selectedMenu.locked) {

                    <span class="badge bg-danger">
                      Locked
                    </span>

                  }


                  @if (selectedMenu.passcode) {

                    <span class="badge bg-primary">
                      Passcode
                    </span>

                  }


                  @if (selectedMenu.sa_only) {

                    <span class="badge bg-warning text-dark">
                      Super Admin Only
                    </span>

                  }


                  @if (selectedMenu.for_module) {

                    <span class="badge bg-info text-dark">
                      For Module
                    </span>

                  }

                </div>

              </div>

            </div>

          </div>

        </div>


        <div class="modal-footer">

          <button
            type="button"
            class="btn btn-light border"
            (click)="closeViewModal()">

            Close

          </button>


          <button
            type="button"
            class="btn btn-primary"
            (click)="
              closeViewModal();
              openEditModal(selectedMenu!)
            ">

            <i class="bi bi-pencil me-2"></i>

            Edit

          </button>

        </div>

      </div>

    </div>

  </div>

}


<!-- ==========================================================
     DELETE MODAL
=========================================================== -->

@if (showDeleteModal && selectedMenu) {

  <div class="modal-backdrop-custom">

    <div class="modal modal-dialog modal-sm modal-dialog-centered">

      <div class="modal-content border-0 shadow-lg">

        <div class="modal-body text-center p-4">

          <div class="delete-icon mx-auto mb-3">

            <i class="bi bi-trash"></i>

          </div>


          <h5 class="fw-bold">
            Delete Menu Item?
          </h5>


          <p class="text-muted">

            Are you sure you want to delete

            <strong>
              {{ selectedMenu.title }}
            </strong>

            ?

          </p>


          <p class="small text-warning">

            <i class="bi bi-info-circle me-1"></i>

            Child menus will be moved to Main Menu.

          </p>


          <div class="d-flex justify-content-center gap-2">

            <button
              type="button"
              class="btn btn-light border"
              (click)="closeDeleteModal()">

              Cancel

            </button>


            <button
              type="button"
              class="btn btn-danger"
              (click)="deleteMenu()">

              <i class="bi bi-trash me-2"></i>

              Delete

            </button>

          </div>

        </div>

      </div>

    </div>

  </div>

}


<!-- ==========================================================
     JSON MODAL
=========================================================== -->

@if (showJsonModal) {

  <div class="modal-backdrop-custom">

    <div class="modal modal-dialog modal-lg modal-dialog-centered">

      <div class="modal-content border-0 shadow-lg">

        <div class="modal-header">

          <h5 class="modal-title fw-bold">

            <i class="bi bi-code-slash me-2"></i>

            Dynamic Menu JSON

          </h5>


          <button
            type="button"
            class="btn-close"
            (click)="closeJsonModal()">
          </button>

        </div>


        <div class="modal-body">

          <div class="json-preview">

            <pre>{{ menuJson }}</pre>

          </div>

        </div>


        <div class="modal-footer">

          <button
            type="button"
            class="btn btn-light border"
            (click)="closeJsonModal()">

            Close

          </button>

        </div>

      </div>

    </div>

  </div>

}
